<template>
    <div class="main">
        <div class="main-content">
            <div class="main-left ">
                <div class="product-wrap boxshadow2">
                    <div class="item">
                        <div class="product-img">
                            <img :src="product.image" alt="">
                        </div>
                        <div class="product-attached">
                            <span v-for="(item,index) in originProduct.attachments" :key="`attached_${index}`">
                                <img v-if="index<6" :src="item" alt="" width="44px" height="44px">
                            </span>
                        </div>
                        <div class="product-price">
                            <span>${{originProduct.price}}</span>
                        </div>
                        <div class="product-title" :title="originProduct.title">
                            {{originProduct.title}}
                        </div>
                        <div class="product-comments">
                            <span>9888+ </span> comments
                        </div>
                        <div class="product-shop">
                    <span>
                        {{originProduct.brand}}
                        <i class="iconfont iconownbrand"></i>
                    </span>
                        </div>
                    </div>
                </div>
                <div class="basics-section boxshadow2">
                    <div class="basics-section-main">
                        <div class="head picture">
                            <span class="head-1">图片编辑</span>
                            <span class="head-2">Picture editing</span>
                        </div>
                        <div class="cont">
                            <div class="img-upload-wrap">
                                <el-upload
                                        action="/student/product/images"
                                        class="avatar-uploader"
                                        :show-file-list="false">
                                    <img v-if="product.image" :src="product.image" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <div class="upload-description">
                                    <span style="color: #E50011;font-weight: bolder;font-size: 18px">主图</span>
                                    <span>
                                        图片地址：
                                    </span>
                                    <span>
                                        <el-input placeholder="请输入内容" v-model="product.image"></el-input>
                                    </span>
                                </div>
                            </div>
                            <div class="img-upload-wrap" v-for="(item,index) in product.attachments"
                                 :key="`upload_${index}`">
                                <el-upload
                                        class="avatar-uploader"
                                        :show-file-list="false"
                                        :on-success="(response,file,fileList)=>{return handleAvatarSuccess(response,file,fileList,index)}"
                                        action="/student/product/images">
                                    <img v-if="item" :src="item" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <div class="upload-description">
                                    <div class="tit" style="">
                                        <span>附图</span>
                                        <span @click="product.attachments.splice(index,1)">删除</span>
                                    </div>
                                    <span>
                                        图片地址：
                                    </span>
                                    <span>
                                        <el-input placeholder="请输入内容" v-model="product.attachments[index]"></el-input>
                                    </span>
                                </div>
                            </div>
                            <div class="add-new-avatar" @click="addNewAvatar">
                                新增描述图
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="main-right">
                <div class="basics-section boxshadow2">
                    <div class="basics-section-main">
                        <div class="head">
                            <span class="head-1">基本信息</span>
                            <span class="head-2">Basic Information</span>
                        </div>
                        <div class="cont paddingright">
                            <el-form ref="baseform" :model="product" label-width="180px" size="big" class="edit-product" :rules="productRules">
                                <el-form-item label="Product Name" prop="title">
                                    <el-input v-model="product.title"></el-input>
                                </el-form-item>
                                <el-form-item label="Tags">
                                    <div class="multiple-wrap" :class="{err:product.tags.length<5}" @click.self="inputFocus($event)">
                                        <div class="item" v-for="(tag,index) in product.tags" :key="`tag_${index}`">
                                            <span>{{tag}}</span>
                                            <i class="el-icon-circle-close" @click="removeItem(tag,'tags')"></i>
                                        </div>
                                        <input type="text" class="tag" v-model="add.tags" @blur="addItem('tags')"
                                               @keydown.enter.prevent="addItem('tags')">
                                    </div>
                                </el-form-item>
                                <el-form-item  label="Keywords">
                                    <div class="multiple-wrap" :class="{err:product.keywords.length<5}"  @click.self="inputFocus($event)">
                                        <div class="item" v-for="(keyword,index) in product.keywords"
                                             :key="`keyword_${index}`">
                                            <span>{{keyword}}</span>
                                            <i class="el-icon-circle-close" @click="removeItem(keyword,'keywords')"></i>
                                        </div>
                                        <input type="text" v-model="add.keywords" @blur="addItem('keywords')"
                                               @keydown.enter.prevent="addItem('keywords')">
                                    </div>
                                </el-form-item>
                                <el-form-item label="Suit Festival">
                                    <div class="multiple-wrap" @click.self="inputFocus($event)">
                                        <div class="item" v-for="(suit,index) in product.suitFestival" :key="`suitFestival_${index}`">
                                            <span>{{suit}}</span>
                                            <i class="el-icon-circle-close" @click="removeItem(suit,'suitFestival')"></i>
                                        </div>
                                        <input type="text" class="tag" v-model="add.suitFestival" @blur="addItem('suitFestival')"
                                               @keydown.enter.prevent="addItem('suitFestival')">
                                    </div>
                                </el-form-item>
                                <el-form-item label="Suit Country">
                                    <div class="multiple-wrap" @click.self="inputFocus($event)">
                                        <div class="item" v-for="(country,index) in product.suitCountry" :key="`suitCountry_${index}`">
                                            <span>{{country}}</span>
                                            <i class="el-icon-circle-close" @click="removeItem(country,'suitCountry')"></i>
                                        </div>
                                        <input type="text" class="tag" v-model="add.suitCountry" @blur="addItem('suitCountry')"
                                               @keydown.enter.prevent="addItem('suitCountry')">
                                    </div>
                                </el-form-item>
                                <el-form-item prop="brand" label="Brand">
                                    <el-input v-model="product.brand"></el-input>
                                </el-form-item>
                                <el-form-item prop="sku" label="SKU">
                                    <el-input v-model="product.sku"></el-input>
                                </el-form-item>
                                <el-form-item prop="description" label="Description">
                                    <el-input :autosize="{ minRows: 5}" type="textarea"
                                              v-model="product.description"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="head label">
                            <span class="head-1">价格设置</span>
                            <span class="head-2">Label editing</span>
                        </div>
                        <div class="cont">
                            <el-form :inline="true" ref="PriceForm" :model="product" label-width="180px" size="big"
                                     class="edit-product" :rules="productRules">
                                <el-form-item prop="price" label="Price">
                                    <el-input v-model="product.price"></el-input>
                                </el-form-item>
                                <el-form-item prop="msrp" label="MSRP">
                                    <el-input v-model="product.msrp"></el-input>
                                </el-form-item>
                                <el-form-item prop="logistic" label="Logistic">
                                    <el-input v-model="product.logistic"></el-input>
                                </el-form-item>
                                <el-form-item prop="inventory" label="Inventory">
                                    <el-input v-model="product.inventory"></el-input>
                                </el-form-item>
                                <el-form-item prop="timeliness" label="TimeLiness">
                                    <el-input v-model="product.timeliness"></el-input>
                                </el-form-item>
                                <el-form-item prop="upc" label="UPC">
                                    <el-input v-model="product.upc"></el-input>
                                </el-form-item>
                                <el-form-item label="Profits">
                                    <el-input v-model="product.profits" :disabled="true"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>

                        <div class="head label">
                            <span class="head-1">物流设置</span>
                            <span class="head-2">Label editing</span>
                        </div>
                        <div class="cont">
                            <el-form :inline="true" ref="logisticsForm" :model="product" label-width="180px" size="big"
                                     class="edit-product" :rules="productRules">
                                <el-form-item prop="declareName" label="Declare Name">
                                    <el-input v-model="product.declareName"></el-input>
                                </el-form-item>
                                <el-form-item prop="declareLocalName" label="Declare Local Name">
                                    <el-input v-model="product.declareLocalName"></el-input>
                                </el-form-item>
                                <el-form-item prop="packageLength" label="Package Length">
                                    <el-input v-model="product.packageLength"></el-input>
                                </el-form-item>
                                <el-form-item prop="packageWeight" label="Package Width">
                                    <el-input v-model="product.packageWeight"></el-input>
                                </el-form-item>
                                <el-form-item prop="packageHeight" label="Package Height">
                                    <el-input v-model="product.packageHeight"></el-input>
                                </el-form-item>
                                <el-form-item prop="customHsCode" label="Custom HS Code">
                                    <el-input v-model="product.customHsCode"></el-input>
                                </el-form-item>
                                <el-form-item prop="weight" label="Weight">
                                    <el-input v-model="product.weight"></el-input>
                                </el-form-item>
                                <el-form-item prop="packageWeight" label="Package Weight">
                                    <el-input v-model="product.packageWeight"></el-input>
                                </el-form-item>
                                <el-form-item prop="countryOfOrigin" label="Country Of Origin">
                                    <el-input v-model="product.countryOfOrigin"></el-input>
                                </el-form-item>
                                <el-form-item prop="customDeclareValue" label="Custom Declare Value">
                                    <el-input type="number" v-model="product.customDeclareValue"></el-input>
                                </el-form-item>
                                <el-form-item label=" ">
                                    <el-checkbox border size="big" v-model="product.hasPowder">Powder</el-checkbox>
                                    <el-checkbox border v-model="product.hasLiquid">Liquid</el-checkbox>
                                    <el-checkbox border v-model="product.hasBattery">Battery</el-checkbox>
                                    <el-checkbox border v-model="product.hasReturn">Return</el-checkbox>
                                    <el-checkbox border v-model="product.hasRefund">Refund</el-checkbox>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main-footer">
            <div class="btn active" @click="submitProduct">
                修改
            </div>
            <div class="btn active" @click="$emit('closeDig')">
                关闭
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EditProduct",
        data() {
            return {
                add: {
                    tags: '',
                    keywords: '',
                    suitFestival:'',
                    suitCountry:''
                },
                product: {
                    title:'',
                    tags:[],
                    keywords:[],
                    suitFestival:[],
                    suitCountry:[],
                    brand:'',
                    sku:'',
                    description:'',
                    price:'',
                    msrp:'',
                    logistic:'',
                    inventory:'',
                    timeliness:'',
                    upc:'',
                    profits:'',
                    declareName:'',
                    declareLocalName:'',
                    packageLength:'',
                    packageWidth:'',
                    packageHeight:'',
                    customHsCode:'',
                    weight:'',
                    packageWeight:'',
                    countryOfOrigin:'',
                    customDeclareValue:'',
                    hasPowder:false,
                    hasLiquid:false,
                    hasBattery:false,
                    hasReturn:false,
                    hasRefund:false
                },
                productRules:{
                    title:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    tags:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    keywords:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    suitFestival:[],
                    suitCountry:[],
                    brand:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    sku:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    description:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    price:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    msrp:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    logistic:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    inventory:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    timeliness:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    upc:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    profits:'',
                    declareName:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    declareLocalName:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    packageLength:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    packageWidth:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    packageHeight:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    customHsCode:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    weight:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    packageWeight:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    countryOfOrigin:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    customDeclareValue:[
                        {required: true, message: '必填项', trigger: 'blur'},
                    ]
                }
            }
        },
        props: ['optimizeProductData','submitData'],
        computed:{
            originProduct(){
                return this.optimizeProductData
            }
        },
        created() {
            let $product = JSON.parse(JSON.stringify(this.optimizeProductData))
            this.product = $product
        },
        methods: {
            handleAvatarSuccess(response,file,fileList,index){
                if(response.succeed && response.login){
                    this.$set(this.product.attachments,index,response.path)
                }
            },
            addNewAvatar() {
                if(this.product.attachments.length >= 10){
                    this.$message.error('附图不能大于10张');
                    return false;
                }
                this.product.attachments.push('')
            },
            submitProduct() {
                let $valid = false;
                this.$refs['baseform'].validate((valid) => {
                    if (!valid) {
                        $valid = true
                    }
                });
                this.$refs['PriceForm'].validate((valid) => {
                    if (!valid) {
                        $valid = true
                    }
                });
                this.$refs['logisticsForm'].validate((valid) => {
                    if (!valid) {
                        $valid = true
                    }
                });
                if($valid){
                    this.$message.error('有必填项未填写，请检查后重试')
                    return false;
                }
                if(!this.product.image){
                    this.$message.error('请上传主图')
                    return false
                }
                if(!(this.product.attachments.length > 2)){
                    this.$message.error('产品的附图不能少于3张')
                    return false
                }
                this.axios.post(`/student/product/${this.submitData.url}`, this.product).then(res => {
                    if (res.succeed) {
                        this.$message.success(res.message);
                        this.$emit('closeDig', true)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },
            inputFocus(e) {
                e.target.lastElementChild.focus()
            },
            addItem(name) {
                if (this.add[name].trim() === '') return false;
                this.product[name].push(this.add[name]);
                this.add[name] = '';
            },
            removeItem(item, arrayName) {
                let index = this.product[arrayName].indexOf(item)
                if (index !== -1) {
                    this.product[arrayName].splice(index, 1)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .main {
        display: flex;
        flex-direction: column;

        div.main-content {
            display: flex;
            margin-bottom: 20px;

            div.main-left {
                display: flex;
                flex-direction: column;
                margin-right: 28px;
                width: 452px;

                div.product-wrap {
                    background: #FFFFFF;
                    border-radius: 16px;
                    margin-bottom: 20px;

                    .item {
                        width: 388px;
                        height: 712px;
                        margin: 54px 32px;
                        border: 2px solid #adadad;
                        border-radius: 20px;
                        box-sizing: border-box;
                        padding: 24px;
                        /*background: #f5f5f5;*/
                        display: flex;
                        flex-direction: column;
                        position: relative;

                        > .product-img {
                            width: 100%;
                            height: 0;
                            padding-bottom: 100%;
                            overflow: hidden;
                            position: relative;

                            img {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                max-width: 100%;
                                height: 100%;
                            }
                        }

                        > .product-attached {
                            margin: 12px 0;
                            display: flex;
                            align-items: center;
                            justify-content: space-around;

                            span {
                                display: inherit;

                                > img {
                                    margin-right: 12px;

                                    &:last-child {
                                        margin-right: 0;
                                    }
                                }
                            }
                        }

                        > .product-price {
                            font-size: 34px;
                            margin: 18px 0;
                            color: #E50011;

                        }

                        > .product-title {

                            font-size: 18px;
                            color: #595757;
                            text-overflow: ellipsis;
                            line-height: 20px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            margin-bottom: 18px;
                        }

                        > .product-comments {
                            font-size: 18px;
                            line-height: 20px;
                            color: #adadad;
                            margin: 18px 0;

                            > span {

                                font-weight: bolder;
                                color: #089BAB;
                            }
                        }

                        > .product-shop {
                            span {
                                display: flex;
                                align-items: center;
                                font-size: 18px;
                                line-height: 20px;
                                color: #adadad;

                                i {
                                    margin-left: 8px;
                                    font-size: 28px;
                                    color: #089BAB;
                                }
                            }
                        }

                    }
                }

                div.basics-section {
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    background: #FFFFFF;
                    border-radius: 16px;
                }
            }

            div.main-right {
                display: flex;
                flex-direction: column;
                flex-grow: 2;
            }
        }

        div.main-footer {
            display: flex;
            align-items: center;
            justify-content: center;

            > .btn {
                width: 100%;
                text-align: center;

                &:first-child {
                    margin-right: 0;
                    border-bottom-right-radius: 0;
                    border-top-right-radius: 0;
                }

                &:last-child {
                    margin-left: 0;
                    border-bottom-left-radius: 0;
                    border-top-left-radius: 0;
                    background: #adadad;
                }
            }
        }

    }


    ::v-deep .avatar-uploader .el-upload {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #089BAB;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #089BAB;
        width: 112px;
        height: 112px;
        line-height: 112px;
        text-align: center;
        border-radius: 10px;
    }

    .add-new-avatar {
        border: 1px dashed #089bab;
        cursor: pointer;
        text-align: center;
        color: #089bab;
        height: 60px;
        line-height: 60px;
        border-radius: 10px;
        transition: all 0.3s linear;

        &:hover {
            transition: all 0.3s linear;
            border-color: #FDAD53;
            color: #FDAD53;
        }
    }

    .avatar {
        border-radius: 10px;
        width: 112px;
        height: 112px;
        display: block;
    }
</style>
